// extracted by mini-css-extract-plugin
module.exports = {"container":"wK","hide":"wL","content":"wM","close":"wN","closeIcon":"wO","svgStyles":"wP"};